import { render, staticRenderFns } from "./RomaFilterLesson.vue?vue&type=template&id=5a7fa770&scoped=true&"
import script from "./RomaFilterLesson.vue?vue&type=script&lang=js&"
export * from "./RomaFilterLesson.vue?vue&type=script&lang=js&"
import style0 from "./RomaFilterLesson.vue?vue&type=style&index=0&id=5a7fa770&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a7fa770",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
